var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPending(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 12C2 17.5263 6.47368 22 12 22C17.5263 22 22 17.5263 22 12C22 6.47368 17.5263 2 12 2C6.47368 2 2 6.47368 2 12ZM6.66667 12C6.66667 11.2632 7.26316 10.6667 8 10.6667C8.73684 10.6667 9.33333 11.2632 9.33333 12C9.33333 12.7368 8.73684 13.3333 8 13.3333C7.26316 13.3333 6.66667 12.7368 6.66667 12ZM10.6667 12C10.6667 11.2632 11.2632 10.6667 12 10.6667C12.7368 10.6667 13.3333 11.2632 13.3333 12C13.3333 12.7368 12.7368 13.3333 12 13.3333C11.2632 13.3333 10.6667 12.7368 10.6667 12ZM14.6667 12C14.6667 11.2632 15.2632 10.6667 16 10.6667C16.7368 10.6667 17.3333 11.2632 17.3333 12C17.3333 12.7368 16.7368 13.3333 16 13.3333C15.2632 13.3333 14.6667 12.7368 14.6667 12Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPending);
export default __webpack_public_path__ + "static/media/pending.61e85f7f.svg";
export { ForwardRef as ReactComponent };